module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Elizabeth Bernstein\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Elizabeth Bernstein is professor of women’s, gender, and sexuality studies and of sociology at Barnard College, Columbia University, and the author of "), _c('I', [_vm._v("Temporarily Yours: Intimacy, Authenticity, and the Commerce of Sex")]), _vm._v(", also published by the University of Chicago Press."), _c('br'), _vm._v("  ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/19CpTHT/tc-custom/9780226573809.jpg?1737331074660",
      "alt": "This image is the cover for the book Brokered Subjects"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Brokered Subjects\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('i', [_vm._v("Brokered Subjects")]), _vm._v(" digs deep into the accepted narratives of sex trafficking to reveal the troubling assumptions that have shaped both right- and left-wing agendas around sexual violence. Drawing on years of in-depth fieldwork, Elizabeth Bernstein sheds light not only on trafficking but also on the broader structures that meld the ostensible pursuit of liberation with contemporary techniques of power. Rather than any meaningful commitment to the safety of sex workers, Bernstein argues, what lies behind our current vision of trafficking victims is a transnational mix of putatively humanitarian militaristic interventions, feel-good capitalism, and what she terms carceral feminism: a feminism compatible with police batons.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The University of Chicago Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0